var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecurringSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0996 10.2002V13.8002H14.6996",
    stroke: "#54FF99",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0996 13.7996L12.4811 12.3551C12.9977 11.8586 13.6254 11.4926 14.3121 11.2876C14.9987 11.0827 15.7243 11.0446 16.4286 11.1767C17.1328 11.3087 17.7954 11.6071 18.3611 12.0468C18.9268 12.4866 19.3793 13.0551 19.681 13.7051",
    stroke: "#54FF99",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5996 3V6.59996",
    stroke: "#54FF99",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.099 17.3999L18.7175 18.8444C18.2008 19.3409 17.5731 19.7069 16.8865 19.9119C16.1999 20.1168 15.4743 20.1549 14.77 20.0228C14.0657 19.8908 13.4032 19.5924 12.8375 19.1527C12.2718 18.7129 11.8192 18.1444 11.5176 17.4944",
    stroke: "#54FF99",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0999 20.9999V17.3999H16.5",
    stroke: "#54FF99",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1002 8.84976V6.59979C20.1002 6.1224 19.9105 5.66457 19.573 5.32701C19.2354 4.98944 18.7776 4.7998 18.3002 4.7998H5.70037C5.22298 4.7998 4.76515 4.98944 4.42759 5.32701C4.09003 5.66457 3.90039 6.1224 3.90039 6.59979V19.1997C3.90039 19.677 4.09003 20.1349 4.42759 20.4724C4.76515 20.81 5.22298 20.9996 5.70037 20.9996H9.57031",
    stroke: "#54FF99",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90039 10.2002H7.50034",
    stroke: "#54FF99",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40039 3V6.59996",
    stroke: "#54FF99",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurringSchedule);
export default __webpack_public_path__ + "static/media/recurring-schedule.98d5efb0c71cda979f6e7bf7cb6b1059.svg";
export { ForwardRef as ReactComponent };